import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["CommonModal"], {
    ref: "loadingModal",
    "can-close": false
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "loading-modal" }, [
        _createElementVNode("div", { class: "loading-spinner" }),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, "Carregando...")
        ])
      ], -1 /* HOISTED */)
    ])),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}